import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={37}
            height={36}
            viewBox="0 0 37 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.92 9.538A9.485 9.485 0 0110.407.053h8.278c9.81 0 17.763 7.953 17.763 17.763 0 9.81-7.953 17.763-17.763 17.763-9.81 0-17.763-7.953-17.763-17.763V9.538z"
                fill={theme["#B4E3E1"]}
            />
            <path
                d="M24.901 10.71H12.467a2.665 2.665 0 00-2.664 2.665v8.882a2.665 2.665 0 002.664 2.665h12.434a2.665 2.665 0 002.665-2.665v-8.882a2.664 2.664 0 00-2.665-2.664zm-.509 1.777l-5.175 4.263a.883.883 0 01-1.034.025l-5.207-4.288h11.416zm.51 10.658H12.466a.888.888 0 01-.888-.888v-8.615l5.507 4.53a2.64 2.64 0 001.588.526 2.73 2.73 0 001.641-.551l5.475-4.505v8.615a.888.888 0 01-.889.888z"
                fill={theme["#0D968F"]}
            />
        </svg>
    )
}
  
  export default SvgComponent